import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const WhyBillvast: React.FC = () => {
  const reasons = [{
    title: 'The Ecosystem Effect',
    description: 'One platform, four powerful financial tools working seamlessly together.'
  }, {
    title: 'Diaspora-First Focus',
    description: 'Built specifically to bridge the gap for Nigerians at home and abroad.'
  }, {
    title: 'Trust & Local Expertise',
    description: 'Deep understanding of the Nigerian financial landscape and regulations.'
  }, {
    title: 'Zero Fees on Social Causes',
    description: 'Community crowdfunding with absolutely no platform charges.'
  }];
  return <section id="why-billvast" className="py-24 bg-white border-t border-gray-100" data-id="element-165">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-167">
          <div data-id="element-168">
            <motion.h2 initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-brand-text-dark" data-id="element-169">
              Why choose <span className="text-brand-primary" data-id="element-170">Billvast?</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg text-brand-text-light mb-8" data-id="element-171">
              We are not just another fintech app. We are a comprehensive ecosystem designed to solve real problems for Nigerians globally.
            </motion.p>
            
            <div className="space-y-6" data-id="element-172">
              {reasons.map((reason, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + index * 0.1
            }} className="flex gap-4" data-id="element-173">
                  <CheckCircle2 className="text-brand-primary shrink-0 mt-1" size={24} data-id="element-174" />
                  <div data-id="element-175">
                    <h4 className="font-bold text-lg mb-1 text-brand-text-dark" data-id="element-176">{reason.title}</h4>
                    <p className="text-brand-text-light" data-id="element-177">{reason.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-178">
            <div className="absolute inset-0 bg-brand-primary/10 blur-3xl rounded-full" data-id="element-179" />
            <div className="relative bg-white border border-gray-100 rounded-3xl p-8 shadow-xl shadow-brand-primary/5" data-id="element-180">
              {/* Abstract App UI Representation */}
              <div className="space-y-4" data-id="element-181">
                <div className="h-12 bg-gray-100 rounded-xl w-1/3 mb-8" data-id="element-182" />
                <div className="h-32 bg-gray-50 rounded-2xl w-full border border-gray-100" data-id="element-183" />
                <div className="grid grid-cols-2 gap-4" data-id="element-184">
                  <div className="h-24 bg-gray-50 rounded-2xl border border-gray-100" data-id="element-185" />
                  <div className="h-24 bg-gray-50 rounded-2xl border border-gray-100" data-id="element-186" />
                </div>
                <div className="h-16 bg-brand-primary/10 border border-brand-primary/20 rounded-2xl w-full flex items-center px-4" data-id="element-187">
                  <div className="w-8 h-8 rounded-full bg-brand-primary/30" data-id="element-188" />
                  <div className="ml-4 h-4 bg-brand-primary/30 rounded w-1/2" data-id="element-189" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};